import React, { useState } from "react";
import Form from "../../../../Components/Form";
import Workspace from "../../../../APIController/Workspace";
import Text from "../../../../Components/Text";
import RadioButton from "../../../../Components/Form/RadioButton";

const EditUserPermissionForm = ({afterAction, user})=>{
    const [employeeRole, setEmployeeRole] = useState(true)
    const {employeePermission, managerPermission} = Workspace()

    const handleEditPermission = async()=>{
        employeeRole ? await employeePermission(user.id) : await managerPermission(user.id)

        afterAction()
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        handleEditPermission()
    }

    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={`Berechtigung Speichern`}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{`${user.firstName} Berechtigung bearbeiten`}</Text>
            <RadioButton 
            attribute1={true} attribute2={false} 
            id={"role"} 
            label1={"Mitarbeiter"} label2={"Manager"} 
            checked1={employeeRole === true} checked2={employeeRole === false}
            title={"Rolle"}
            action1={() => setEmployeeRole(true)} action2={() => setEmployeeRole(false)} />
        </Form>
    );
}

export default EditUserPermissionForm